import { useSelector } from 'react-redux';
import { useParams, useLocation, Switch, Route } from 'react-router-dom';
import { selectPolicyDetails } from 'selectors';
import Loading from 'components/loading';
import { POLICY_DETAILS_ROUTE, PROFILE_SHARE_ROUTE } from 'constants/routes';
import PolicyDetailsContainer from './PolicyDetailsContainer';
import PolicyDetailsMobile from './components/PolicyDetailsMobile';
import PolicyDetailsMobileNav from './components/PolicyDetailsMobileNav';
import { MobileBottomNav } from 'containers/layout';

interface IRouteState {
  policyScanId?: string;
}

const PolicyDetailsRoutes = (props) => {
  return (
    <Switch>
      <Route exact={true} path={[POLICY_DETAILS_ROUTE, PROFILE_SHARE_ROUTE]}>
        <PolicyDetailsContainer {...props} />
      </Route>
      <PolicyDetailsMobile {...props} />
    </Switch>
  );
};

const ContainerWithNav = (props) => {
  const { id: routeId } = useParams<{ id: string }>();
  const { state: routeState } = useLocation<IRouteState>();
  const policyScanId = routeState?.policyScanId; // For purchasing MS
  const selectorState = useSelector((state) =>
    selectPolicyDetails(state, routeId),
  );

  return (
    <>
      {selectorState.loading ? (
        <Loading />
      ) : (
        <PolicyDetailsRoutes
          policyId={routeId}
          policyScanId={policyScanId}
          {...selectorState}
          {...props}
        />
      )}
      {selectorState.isCreditCard ? (
        <MobileBottomNav user={selectorState.user} />
      ) : (
        <PolicyDetailsMobileNav {...selectorState} />
      )}
    </>
  );
};

export default ContainerWithNav;
